<template>
  <div class="input-wrap">
    <label >
      <input :aria-label="name" :class="isRequired" :value="value" :name="name" :placeholder="placeholder" @input="$emit('input', $event.target.value)">
      <span class="input-outline"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    value: String,
    name: String,
    required: Boolean,
  },
  computed: {
    isRequired() {
      return this.required ? 'required' : '';
    },
  },
};
</script>

<style scoped>
</style>
